import React, { useState } from 'react'
import { Form, Tabs, Input, Button } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import "./settings.css"
import { MdManageAccounts, MdMarkEmailRead } from "react-icons/md";
// import { AiFillContacts } from "react-icons/ai";
import { SiGnuprivacyguard } from "react-icons/si";
import { BiHide } from "react-icons/bi";
import { Link } from 'react-router-dom';
// import ContactFiltering from './SettingComponents/ContactFiltering';
import EmailAlert from './SettingComponents/EmailAlert';
import PrivacyOptions from './SettingComponents/PrivacyOptions';
import { useCookies } from 'react-cookie'
import { useDispatch, useSelector } from 'react-redux';
import { changePassword, changeVisibility, deleteProfile } from '../../Redux/features/User/userSlice';
import Swal from 'sweetalert2';
import { FcContacts } from 'react-icons/fc';
import ContactDetails from './SettingComponents/ContactDetails';


const Settings = () => {
    const [form] = Form.useForm();
    const [isPasswordEdit, setIsPasswordEdit] = useState(false);
    const {user} = useSelector(state => state.user);
    const [isVisibile, setIsVisible] = useState(user.userStatus.isVisible);
    //eslint-disable-next-line
    const [cookies, setCookie, removeCookie] = useCookies(['x-auth-token']);
    let data = {
        header: cookies['x-auth-token'],
    }
    const dispatch = useDispatch();

    const handleDeleteProfile = async () => {
        const result = await Swal.fire({
            title: 'Are you sure you want to Delete the Profile?',
            text: "You won't be able to revert this!",
            icon: 'error',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Deleted it!'
        })
        if (result.isConfirmed) {
            Swal.fire(
                'Deleted!',
                'Your Account has been Deleted.',
                'success'
            )
            removeCookie('x-auth-token');
            dispatch(deleteProfile(data));
        }
    }

    const handleVisibility = () => {
        dispatch(changeVisibility({ ...data, ...{ isVisible: !isVisibile } }));
        setIsVisible(!isVisibile);
    }

    const validatePassword = (_, value) => {
        const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
        if (!value || regex.test(value)) {
            return Promise.resolve();
        }
        return Promise.reject(
            'Password must be at least 8 characters long, start with a capital letter, and contain at least one digit and one special character.'
        );
    };

    const validateConfirmPassword = (_, value) => {
        const password = form.getFieldValue('password');
        if (value && value !== password) {
            return Promise.reject('Passwords do not match.');
        }
        return Promise.resolve();
    };

    const handleChangePassword = () => {
        form.validateFields().then((values) => {
            dispatch(changePassword({ ...data, ...values }));
        });
        setIsPasswordEdit(false);
        form.resetFields();
    }
    const cancelChange = () => {
        form.resetFields();
        setIsPasswordEdit(false);
    }

    return (
        <div className='container settings backgroundLight'>
            <div className='settingsTitle'>Settings</div>
            <Tabs
                tabPosition="left"
                defaultActiveKey="1">
                <Tabs.TabPane tab={<span><MdManageAccounts size={25} />Account Settings</span>} key="1">
                    <div className='tabHeading'>My Account</div>
                    <div className='tabContent'>
                        <div className="customCard">
                            <div className="customCardTitle backgroundGrey">
                                <div>Email</div>
                            </div>
                            <div className="customCardBody backgroundLight row">
                                <div className="col-md-4">Email</div>
                                <div className="col-md-4">
                                    <div>: {user.email}</div>
                                </div>
                            </div>
                        </div>
                        <div className="customCard">
                            <div className="customCardTitle backgroundGrey">
                                <div>Password</div>
                                <Link onClick={() => setIsPasswordEdit(true)}>Edit</Link>
                            </div>
                            <div className="customCardBody backgroundLight row">
                                <div className="col-md-4">Email</div>
                                <div className="col-md-4">
                                    {isPasswordEdit ? (
                                        <Form
                                            form={form}
                                            name="passwordChange"
                                            onFinish={handleChangePassword}
                                            scrollToFirstError
                                        >
                                            <Form.Item
                                                name="password"
                                                rules={[
                                                    { required: true, message: 'Please input your password!' },
                                                    { validator: validatePassword },
                                                ]}
                                            >
                                                <Input.Password
                                                    prefix={<LockOutlined />}
                                                    placeholder="Password"
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                name="confirmPassword"
                                                dependencies={['password']}
                                                rules={[
                                                    { required: true, message: 'Please confirm your password!' },
                                                    { validator: validateConfirmPassword },
                                                ]}
                                            >
                                                <Input.Password
                                                    prefix={<LockOutlined />}
                                                    placeholder="Confirm Password"
                                                />
                                            </Form.Item>
                                            <Form.Item>
                                                <Button type="primary" htmlType="submit">
                                                    Save
                                                </Button>
                                                <Button style={{ marginLeft: 20 }} onClick={cancelChange}>
                                                    Cancle
                                                </Button>
                                            </Form.Item>
                                        </Form>
                                    ) : <div>: ********</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </Tabs.TabPane>
                {/* <Tabs.TabPane tab={<span><AiFillContacts size={25} />Contact Filters</span>} key="2">
                    <ContactFiltering user={user} />
                </Tabs.TabPane> */}
                <Tabs.TabPane tab={<span><MdMarkEmailRead size={25} />Email Alerts</span>} key="3">
                    <EmailAlert />
                </Tabs.TabPane>
                <Tabs.TabPane tab={<span><SiGnuprivacyguard size={25} />Privacy Options</span>} key="4">
                    <PrivacyOptions />
                </Tabs.TabPane>
                <Tabs.TabPane tab={<span><BiHide size={25} />Hide/Delete Profile</span>} key="5">
                    <div className='tabHeading'>Hide / Delete Profile</div>
                    <div className='tabContent'>
                        <div className="customCard">
                            <div className="pdCard">
                                <div className="listing row">
                                    <div className="col-md-6 d-flex justify-content-between">
                                        <div className="">{isVisibile ? "Hide Profile" : "Show Profile"}</div>
                                        <div className="">Your Profile is currently {isVisibile ? "visible" : "hidden"}</div>
                                    </div>
                                    <div className="col-md-6 d-flex justify-content-end">
                                        <Link onClick={handleVisibility}>{isVisibile ? "Hide" : "Show"}</Link>
                                    </div>
                                </div>
                                <div className="listing row">
                                    <div className="col-md-6 d-flex justify-content-between">
                                        <div className="">Delete Profile</div>
                                        <div className="">Delete your Profile from Lovodi.com</div>
                                    </div>
                                    <div className="col-md-6 d-flex justify-content-end">
                                        <Link onClick={handleDeleteProfile}>Delete</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Tabs.TabPane>
                <Tabs.TabPane tab={<span><FcContacts size={25} />Contact Details</span>} key="6">
                    <ContactDetails />
                </Tabs.TabPane>
            </Tabs>
        </div>
    )
}

export default Settings

